/**
 * Shallow copy of `obj` without `keys`.
 *
 * Keys outside `keyof T` are allowed (and stripped at runtime) so that fields
 * the server sends but the DTO does not declare can still be removed.
 */
export const omit = <T extends object, K extends PropertyKey>(
  obj: T,
  keys: readonly K[]
): Omit<T, Extract<keyof T, K>> => {
  const copy = { ...obj };

  for (const key of keys) {
    Reflect.deleteProperty(copy, key);
  }

  return copy;
};
